import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function Impressum() {
  return (
    <div className="min-h-screen bg-[#09090B] py-12 px-4">
      <div className="max-w-3xl mx-auto">
        <Link 
          to="/"
          className="inline-flex items-center gap-2 text-zinc-400 hover:text-zinc-50 transition-colors mb-8"
        >
          <ArrowLeft className="w-4 h-4" />
          Zurück
        </Link>

        <h1 className="text-4xl font-black tracking-tighter text-zinc-50 mb-8" style={{ fontFamily: 'Chivo, sans-serif' }}>
          Impressum
        </h1>

        <div className="space-y-8 text-zinc-300">
          <section>
            <h2 className="text-xl font-semibold text-yellow-500 mb-4">Angaben gemäß § 5 TMG</h2>
            <p>
              manage4yougroup UG (haftungsbeschränkt)<br />
              Am Kahlberg 8<br />
              91093 Heßdorf
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-yellow-500 mb-4">Vertreten durch</h2>
            <p>Geschäftsführerin: Samantha Jane Hotz</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-yellow-500 mb-4">Kontakt</h2>
            <p>
              Telefon: 09135 7189445<br />
              E-Mail: sebastian.hotz@manage4yougroup.de<br />
              E-Mail: justin.hotz@manage4yougroup.de
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-yellow-500 mb-4">Registereintrag</h2>
            <p>
              Eintragung im Handelsregister<br />
              Registergericht: Amtsgericht Fürth<br />
              Registernummer: HRB 21092
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-yellow-500 mb-4">Umsatzsteuer-ID</h2>
            <p>
              Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br />
              DE414093503
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-yellow-500 mb-4">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
            <p>
              Samantha Jane Hotz<br />
              Am Kahlberg 8<br />
              91093 Heßdorf
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-yellow-500 mb-4">Streitschlichtung</h2>
            <p className="text-zinc-400">
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: 
              <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-yellow-500 hover:underline ml-1">
                https://ec.europa.eu/consumers/odr/
              </a>
            </p>
            <p className="text-zinc-400 mt-2">
              Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-yellow-500 mb-4">Haftung für Inhalte</h2>
            <p className="text-zinc-400">
              Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
